module.exports = __webpack_public_path__ + "img/14.bdef3252.png";